import classNames from 'classnames';
import { forwardRef } from 'react';
import { Tooltip as BootstrapTooltip } from 'react-bootstrap';
import type { TooltipProps as BootstrapTooltipProps } from 'react-bootstrap';

import styles from './_index.module.scss';

export interface TooltipProps extends BootstrapTooltipProps {
  isFullWidth?: boolean;
}

const Tooltip = (
  { className, isFullWidth, ...props }: TooltipProps,
  ref?: React.ForwardedRef<HTMLDivElement>
) => {
  return (
    <BootstrapTooltip
      className={classNames(
        styles['tooltip'],
        {
          [styles['is-full-width']]: isFullWidth,
        },
        className
      )}
      {...props}
      ref={ref}
    />
  );
};

const TooltipWithRef = forwardRef(Tooltip);

export default TooltipWithRef;
